import { defineComponent as _defineComponent } from 'vue'
import BeforeAfterList from "@/components/list/BeforeAfterList.vue";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "../table/ApprovalChip.vue";
import { DateTime } from "luxon";
import { ApprovalShiftUser } from "@/models/approval/ApprovalResponse";
import { ShiftFlowDat } from "@/models/transaction/ShiftFlowDat";

type Props = {
  dat: ShiftFlowDat;
  approvals: ApprovalShiftUser[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftExpandItem',
  props: {
    dat: null,
    approvals: null
  },
  setup(__props: any) {

const beforeHeader = [
  { text: "シフト名： ", value: "preShiftpatternNm" },
  { text: "シフト開始時間： ", value: "preStartTime" },
  { text: "シフト終了時間： ", value: "preEndTime" },
  { text: "シフト総休憩時間： ", value: "preBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "preMidnightBreakTime" }
] as const;

const afterHeader = [
  { text: "シフト名： ", value: "afterShiftpatternNm" },
  { text: "シフト開始時間： ", value: "afterStartTime" },
  { text: "シフト終了時間： ", value: "afterEndTime" },
  { text: "シフト総休憩時間： ", value: "afterBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "afterMidnightBreakTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};



return { __sfc: true,beforeHeader, afterHeader, approvalHeaders, formatDate, BeforeAfterList, ApprovalChip }
}

})